import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RankView from '../views/RankView.vue'
import NewVew from '@/views/NewVew.vue'
import DetailsView from '@/views/DetailsView.vue'
import AboutView from '@/views/AboutView.vue'
import SearchView from "@/views/SearchView.vue"
import UserView from "@/views/UserView.vue"
import SearchAuthorView from "@/views/SearchAuthorView.vue"
import musicView from "@/views/musicView.vue"
import vedio from "@/views/vedio.vue"


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
  {
    path: '/rank',
    name: 'rank',
    component: RankView
  },
  {
    path: '/new',
    name: 'new',
    component: NewVew
  },
  {
    path: '/details/',
    name: 'details',
    component: DetailsView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView
  },
  {
    path: '/userArt/',
    name: 'userArt',
    component: UserView
  },
  {
    path: '/searchAuthor/',
    name: 'searchAuthor',
    component: SearchAuthorView
  },
  {
    path: '/music/',
    name: 'music',
    component: musicView
  },
  {
    path: '/vedio/',
    name: 'vedio',
    component: vedio
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeResolve((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresResolve)) {
//     Promise.all([])
//   }
// })

export default router
